import { Input, Link, Textarea } from '@nimbus-ds/components';
import { CardWithTitle, Stack } from 'commons/components';
import { SplitSection } from '../SplitSection';

export function Skeleton() {
  return (
    <CardWithTitle title="Google">
      <Stack column spacing="loose" align="stretch">
        <SplitSection.Skeleton>
          <Input.Skeleton />
        </SplitSection.Skeleton>
        <SplitSection.Skeleton>
          <Input.Skeleton />
          <Input.Skeleton />
          <Link.Skeleton />
        </SplitSection.Skeleton>
        <SplitSection.Skeleton>
          <Textarea.Skeleton />
          <Link.Skeleton />
        </SplitSection.Skeleton>
        <SplitSection.Skeleton>
          <Input.Skeleton />
          <Link.Skeleton />
        </SplitSection.Skeleton>
      </Stack>
    </CardWithTitle>
  );
}
